import React from "react";
import {
  Datagrid,
  List,
  TextField,
  TextInput,
  SimpleForm,
  SelectArrayInput,
  ReferenceArrayInput,
  ReferenceInput,
  SelectInput,
  Edit,
  Filter,
  SearchInput
} from "react-admin";

export const userRenderer = (record) =>
  `${record.email}`;

  const UserFilter = (props) => (
    <Filter {...props}>
      <SearchInput source="email_contains" alwaysOn />
    </Filter>
  );

export const UserList = (props) => (
  <List {...props} filters={<UserFilter />}>
    <Datagrid rowClick="edit">
      <TextField source="createdAt" />
      <TextField source="email" />
      <TextField source="appleUserId" />

      <TextField source="facebookUserId" />
      <TextField source="name" />
      <TextField source="lastname" />

      
    </Datagrid>
  </List>
);

const UserFormInput = ({ ...props }) => {
  return (
    <SimpleForm {...props} warnWhenUnsavedChanges>
      <TextInput source="createdAt" />
      <TextInput source="email" />
      <TextInput source="appleUserId" />

      <TextInput source="facebookUserId" />
      <TextInput source="name" />
      <TextInput source="lastname" />

      <ReferenceArrayInput
        label="Mindfulness Library"
        reference="Mindfulness"
        source="mindfulnesssInLibraryIds"
      >
        <SelectArrayInput optionText="name" />
      </ReferenceArrayInput>
      <ReferenceArrayInput
        label="Subscriptions"
        reference="Subscription"
        source="subscriptionIds"
      >
        <SelectArrayInput optionText="expiryDate" />
      </ReferenceArrayInput>

      

      <ReferenceInput label="Blog" source="blog.id" reference="Blog">
        <SelectInput optionText="name" />
      </ReferenceInput>
    </SimpleForm>
  );
};
export const UserEdit = (props) => (
  <Edit {...props}>
    <UserFormInput />
  </Edit>
);
